import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const warehouseLocationLocaleModule: LocaleModule = {
  name: "warehouseLocation",
  messages: { en: en, it: it },
};
